import { lazy } from "react";

const CHUNK_RELOAD_KEY = "caf-chunk-reload";

function isChunkLoadError(error) {
  const message = error?.message || "";
  return (
    error?.name === "ChunkLoadError" ||
    /Loading chunk .* failed/i.test(message) ||
    /Failed to fetch dynamically imported module/i.test(message) ||
    /Importing a module script failed/i.test(message)
  );
}

/**
 * iOS Safari often fails to load lazy route chunks (cache / network).
 * Retry once, then reload the page a single time to fetch fresh assets.
 */
export function lazyWithRetry(importFn) {
  return lazy(() =>
    importFn().catch((error) => {
      if (isChunkLoadError(error)) {
        const hasReloaded = sessionStorage.getItem(CHUNK_RELOAD_KEY);

        if (!hasReloaded) {
          sessionStorage.setItem(CHUNK_RELOAD_KEY, "1");
          window.location.reload();
          return new Promise(() => {});
        }

        sessionStorage.removeItem(CHUNK_RELOAD_KEY);
      }

      throw error;
    }),
  );
}

export { isChunkLoadError };
